export default (value, symbol = '£') => {
  if (value === null || value === undefined) return ''
  return `${symbol}${value.toFixed(2)}`
}
